import React from 'react';

import { Song } from 'src/@types/api-types';

import { SCOPE } from 'shared-types/constants';
import { Lyrics as LyricsType } from 'shared-types/lyrics';
import { PlayerSongDetails } from 'shared-types/player-event';
import { SwipeColors } from 'types/swipeColors';

import Lyrics from '../Lyrics';
import MentionSlide from '../MentionSlide';
import Timer from '../Timer';

interface Props {
  videoElement: HTMLVideoElement;
  songDetails?: Song;
  currentSongDetails?: PlayerSongDetails | null;
  videoAreaHeight: number;
  lastManualUpdateTimeInMs: number;
  lyrics?: LyricsType;
  swipeColors?: SwipeColors;
  isPremium: boolean;
  scope: SCOPE;
}

const PlayerContent: React.FC<Props> = ({
  videoElement,
  songDetails,
  currentSongDetails,
  videoAreaHeight,
  lastManualUpdateTimeInMs,
  isPremium,
  swipeColors,
  lyrics,
  scope,
}) => (
  <>
    {songDetails && (
      <MentionSlide
        videoElement={videoElement}
        isPremium={isPremium}
        songDetails={songDetails}
        videoAreaHeight={videoAreaHeight}
        currentSongDetails={currentSongDetails}
      />
    )}
    {lyrics && swipeColors && (
      <>
        <Timer
          videoElement={videoElement}
          timersInfo={lyrics.timers}
          videoAreaHeight={videoAreaHeight}
          lastManualUpdateTimeInMs={lastManualUpdateTimeInMs}
          isPremium={isPremium}
          scope={scope}
        />
        <Lyrics
          videoElement={videoElement}
          lyrics={lyrics}
          videoAreaHeight={videoAreaHeight}
          isPremium={isPremium}
          lastManualUpdateTimeInMs={lastManualUpdateTimeInMs}
          swipeColors={swipeColors}
        />
      </>
    )}
  </>
);
export default PlayerContent;
